import { message } from "antd";
import {
  fetchDelete,
  fetchFinish,
  fetchPublish,
  fetchRemind,
  queryOutboxDetail
} from "../../../../services/dataReport/outbox";
import {addToTemplate} from "../../../../services/dataReport/template";
import { getOptionLabel } from "../util";

const initState = {
  detailKey: Date.now(),
  detail: null,
  id: 0 // list 中获取到的id
};
export default {
  namespace: "dataReportDetail",

  state: initState,

  effects: {
    // 通知发件箱/收件箱详情
    *fetchDetail({ payload }, { call, put }) {
      try {
        const data = yield call(queryOutboxDetail, {...payload });

        // let sortIndex = 1;
        // 数据整理，增加选项索引，初始化 checked
        data.questionList.forEach((item) => {
          if(!item.questionOptionList) {
            item.questionOptionList = [];
          }
          item.questionOptionList.forEach((subItem, subIndex) => {
            subItem.value = subItem.id;
            subItem.option = getOptionLabel(subIndex);
            subItem.checked = false;
            subItem.answerTheQuestions = false;
            subItem.otherOptionDescription = '';
          });
          // 填空题属性
          if(!item.completionList) {
            item.completionList = [];
          }
          item.completionList.forEach(subItem=>{
            if (subItem.type === 'input') {
              subItem.value = '';
            }
          })
        });

        yield put({
          type: "save",
          payload: {
            detail: data,
          }
        });

        return Promise.resolve();

      } catch (error) {
        return Promise.reject();
      }
    },
    *fetchRequest({ payload }, { call }) {
      try {
        const {fetchType, ...params} = payload;

        const fetchMap = {
          "finish": { request: fetchFinish, tip: "调查已结束。" },
          "remind": { request: fetchRemind, tip: "提醒成功。" },
          "delete": { request: fetchDelete, tip: "调查已删除。" },
          "addTemplate": { request: addToTemplate, tip: "成功添加至模板库。" },
        };

        const response = yield call(fetchMap[fetchType].request, params);

        message.success(`${fetchMap[fetchType].tip}`);
        return Promise.resolve(response);

      } catch (error) {
        return Promise.reject();
      }
    }
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload
      };
    },
    reset() {
      return { ...initState };
    }
  }
};
